import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

const useUpdateDoctorStatic = ({
  getAllDoctorStatic = () => {},
  onCloseModal = () => {},
}) => {
  const [isDoctorStaticUpdating, setIsDoctorStaticUpdating] = useState(false);

  const onUpdateDoctorStatic = async (docId, payload, isFormData = false) => {
    setIsDoctorStaticUpdating(true);
    const token = localStorage.getItem("authToken");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "hgs",
      };

      // Only set Content-Type if not FormData (axios will set it automatically for FormData)
      if (!isFormData) {
        headers["Content-Type"] = "application/json";
      }

      await axios.put(
        `/api/v1/phr-app/doctor-static-data/${docId}`,
        payload,
        { headers }
      );
      toast.success("Doctor information updated successfully !");
      getAllDoctorStatic();
      setTimeout(() => {
        onCloseModal();
      }, 1000);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            window.location.href = "/";
          }, 1000);
        }
      }
    } finally {
      setIsDoctorStaticUpdating(false);
    }
  };

  return {
    onUpdateDoctorStatic,
    isDoctorStaticUpdating,
  };
};

export default useUpdateDoctorStatic;

